import { Icon20Hearts2Outline, Icon20SmileAddOutline, Icon24Add } from '@vkontakte/icons';
import { ReactComponent as IconUnlimitedAutoupload } from 'img/icons/unlimited-autoupload-curColor-16.svg';
import React from 'react';

export const defaultTariffFeature = [
    {
        text: 'Безлимит для фото с телефона',
        key: 'unlimited-autoupload',
        icon: <IconUnlimitedAutoupload fill={'#87898f'} />,
        usePropsIcon: true,
    },
    {
        text: 'Удаление дубликатов',
        key: 'duplicates',
    },
    {
        text: 'Добавление ещё 3 участников',
        key: 'family',
    },
    {
        text: 'Без рекламы в Почте и Облаке',
        key: 'ad',
    },
    {
        text: (
            <>
                И другие <a href="https://cloud.mail.ru/promo/quota#benefits">возможности</a>
            </>
        ),
        key: 'benefits',
    },
];

export const familyTariffFeature = [
    {
        text: 'Семейный безлимит',
        key: 'unlimited-autoupload',
        icon: <IconUnlimitedAutoupload fill={'#87898f'} />,
        usePropsIcon: true,
    },
    {
        text: 'Добавление ещё 3 участников',
        key: 'family',
        icon: <Icon20SmileAddOutline height={16} width={16} />,
        usePropsIcon: true,
    },
    {
        text: 'Семейные папки и альбомы',
        key: 'family-folders',
        icon: <Icon20Hearts2Outline height={16} width={16} />,
        usePropsIcon: true,
    },
    {
        text: 'Без рекламы в Почте и Облаке',
        key: 'ad',
    },
    {
        text: (
            <>
                И другие <a href="https://cloud.mail.ru/promo/quota#benefits">возможности</a>
            </>
        ),
        key: 'benefits',
        icon: <Icon24Add height={16} width={16} />,
        usePropsIcon: true,
    },
];
